// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

// src/config.(js|ts)
const config = {
  // ⬇️ change this line
  basename: '/',   // was '/free'
  // other fields...
};

export default config;
